import { Observable, throwError } from 'rxjs';
import {
  HttpEvent,
  HttpHandler,
  HttpRequest,
  HttpInterceptor,
  HttpHeaders,
  HttpErrorResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../src/environments/environment';
import { tap, retry, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class FoodBudInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
  ) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const rentsherAuthToken = sessionStorage.getItem('access_token');
    let dateInMillis = new Date().getTime().toString();
    let headers = req.headers.set('Content-Type', 'application/json');
    if (rentsherAuthToken && this.payload(rentsherAuthToken)) {
      headers = req.headers
        .set('Authorization','Bearer ' + rentsherAuthToken)
        .set('Content-Type', 'application/json');
      if(req.url.includes("import-users")){
        headers = req.headers
        .set('Authorization','Bearer ' + rentsherAuthToken);
        return next.handle(req.clone({ headers })).pipe(
          retry(1),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
              // refresh token
              // this.handle401();
            } else if (error.status === 500) {
            } else {
              // this.handle401();
              return throwError(error);
            }
          })
        );
      }
      if(req.url.includes("userProfileDetail")){
        headers = req.headers
        .set('Authorization','Bearer ' + rentsherAuthToken);
        return next.handle(req.clone({ headers })).pipe(
          retry(1),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
              // refresh token
              // this.handle401();
            } else if (error.status === 500) {
            } else {
              // this.handle401();
              return throwError(error);
            }
          })
        );
      }
      if(req.url.includes("updateUserProfile")){
        headers = req.headers
        .set('Authorization','Bearer ' + rentsherAuthToken);
        return next.handle(req.clone({ headers })).pipe(
          retry(1),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
              // refresh token
              // this.handle401();
            } else if (error.status === 500) {
            } else {
              // this.handle401();
              return throwError(error);
            }
          })
        );
      }
      if(req.url.includes("uploadUserImage")){
        //const headers = new Headers();
        /** In Angular 5, including the header Content-Type can invalidate your request */
        headers = req.
        headers.append('Authorization','Bearer ' + rentsherAuthToken)
        headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', 'application/json');
      //         headers = req.headers
      //   .set('Authorization','Bearer ' + rentsherAuthToken)
      //  .set('Content-Type', 'multipart/form-data')
      //   .set('Accept', 'application/json');
        return next.handle(req.clone({ headers })).pipe(
          retry(1),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
              // refresh token
              // this.handle401();
            } else if (error.status === 500) {
            } else {
              // this.handle401();
              return throwError(error);
            }
          })
        );
      }

      return next.handle(req.clone({ headers })).pipe(
        retry(1),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            sessionStorage.clear(); 
            this.router.navigate(['/public/resto']);
          } else if (error.status === 500) {
          } else {
            // this.handle401();
            return throwError(error);
          }
        })
      );
    } else {
      return next.handle(req.clone({ headers })).pipe(
        tap((err: any) => {
          if (err instanceof HttpErrorResponse) {
            // console.log(err);
            // console.log('req url :: ' + req.url);
            if (err.status === 401) {
              // this.router.navigate(['user']);
            }
            sessionStorage.clear(); 
            this.router.navigate(['/public/resto']);
            window.location.reload()
          }
        })
      );
    }
  }

  redirect() {
    this.router.navigate(['/login'], { replaceUrl: true });
  }
  payload(rentsherAuthToken) {
    const jwtPayload = rentsherAuthToken.split('.')[1];
    let decodeToken =  JSON.parse(atob(jwtPayload));
    return (Math.floor((new Date()).getTime() / 1000)) < decodeToken.expiry;
  }
  
}
